import week1 from './week1';
import week2 from './week2';
import week3 from './week3';
import week4 from './week4';
import week5 from './week5';
import week6 from './week6';
import week7 from './week7';
import week8 from './week8';

const courseContent = {
  1: week1,
  2: week2,
  3: week3,
  4: week4,
  5: week5,
  6: week6,
  7: week7,
  8: week8
};

export const weeks = [week1, week2, week3, week4, week5, week6, week7, week8];

export default courseContent;
